/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AdminChangePasswordForbiddenDto } from '../../src/model';
// @ts-ignore
import type { AdminChangePasswordInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminChangePasswordNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminChangePasswordReqBodyDto } from '../../src/model';
// @ts-ignore
import type { AdminLoginForbiddenDto } from '../../src/model';
// @ts-ignore
import type { AdminLoginInternalServerError } from '../../src/model';
// @ts-ignore
import type { AdminLoginOkDto } from '../../src/model';
// @ts-ignore
import type { AdminLoginReqBodyDto } from '../../src/model';
// @ts-ignore
import type { AdminLoginUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { AdminLogoutInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminRefreshInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminRefreshOkDto } from '../../src/model';
// @ts-ignore
import type { AdminRegisterConflictDto } from '../../src/model';
// @ts-ignore
import type { AdminRegisterCreatedDto } from '../../src/model';
// @ts-ignore
import type { AdminRegisterInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminRegisterNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminRegisterReqBodyDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminAccessGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminRefreshGuardNotFoundDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminRefreshGuardUnauthorizedDto } from '../../src/model';
/**
 * AdminAuthApi - axios parameter creator
 * @export
 */
export const AdminAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 관리자 비밀번호 변경
         * @param {AdminChangePasswordReqBodyDto} adminChangePasswordReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAuthControllerAdminChangePassword: async (adminChangePasswordReqBodyDto: AdminChangePasswordReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminChangePasswordReqBodyDto' is not null or undefined
            assertParamExists('adminAuthControllerAdminChangePassword', 'adminChangePasswordReqBodyDto', adminChangePasswordReqBodyDto)
            const localVarPath = `/admin/auth/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminChangePasswordReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자 로그인
         * @param {AdminLoginReqBodyDto} adminLoginReqBodyDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminAuthControllerAdminLogin: async (adminLoginReqBodyDto: AdminLoginReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminLoginReqBodyDto' is not null or undefined
            assertParamExists('adminAuthControllerAdminLogin', 'adminLoginReqBodyDto', adminLoginReqBodyDto)
            const localVarPath = `/admin/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminLoginReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자 로그아웃
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminAuthControllerAdminLogout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자 토큰 갱신
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAuthControllerAdminRefresh: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자 생성
         * @param {AdminRegisterReqBodyDto} adminRegisterReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAuthControllerAdminRegister: async (adminRegisterReqBodyDto: AdminRegisterReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminRegisterReqBodyDto' is not null or undefined
            assertParamExists('adminAuthControllerAdminRegister', 'adminRegisterReqBodyDto', adminRegisterReqBodyDto)
            const localVarPath = `/admin/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminRegisterReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAuthApi - functional programming interface
 * @export
 */
export const AdminAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 관리자 비밀번호 변경
         * @param {AdminChangePasswordReqBodyDto} adminChangePasswordReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAuthControllerAdminChangePassword(adminChangePasswordReqBodyDto: AdminChangePasswordReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAuthControllerAdminChangePassword(adminChangePasswordReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAuthApi.adminAuthControllerAdminChangePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자 로그인
         * @param {AdminLoginReqBodyDto} adminLoginReqBodyDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async adminAuthControllerAdminLogin(adminLoginReqBodyDto: AdminLoginReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminLoginOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAuthControllerAdminLogin(adminLoginReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAuthApi.adminAuthControllerAdminLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자 로그아웃
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async adminAuthControllerAdminLogout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAuthControllerAdminLogout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAuthApi.adminAuthControllerAdminLogout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자 토큰 갱신
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAuthControllerAdminRefresh(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminRefreshOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAuthControllerAdminRefresh(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAuthApi.adminAuthControllerAdminRefresh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자 생성
         * @param {AdminRegisterReqBodyDto} adminRegisterReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAuthControllerAdminRegister(adminRegisterReqBodyDto: AdminRegisterReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminRegisterCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAuthControllerAdminRegister(adminRegisterReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAuthApi.adminAuthControllerAdminRegister']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminAuthApi - factory interface
 * @export
 */
export const AdminAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAuthApiFp(configuration)
    return {
        /**
         * 
         * @summary 관리자 비밀번호 변경
         * @param {AdminAuthApiAdminAuthControllerAdminChangePasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAuthControllerAdminChangePassword(requestParameters: AdminAuthApiAdminAuthControllerAdminChangePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminAuthControllerAdminChangePassword(requestParameters.adminChangePasswordReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자 로그인
         * @param {AdminAuthApiAdminAuthControllerAdminLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminAuthControllerAdminLogin(requestParameters: AdminAuthApiAdminAuthControllerAdminLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminLoginOkDto> {
            return localVarFp.adminAuthControllerAdminLogin(requestParameters.adminLoginReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자 로그아웃
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminAuthControllerAdminLogout(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminAuthControllerAdminLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자 토큰 갱신
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAuthControllerAdminRefresh(options?: RawAxiosRequestConfig): AxiosPromise<AdminRefreshOkDto> {
            return localVarFp.adminAuthControllerAdminRefresh(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자 생성
         * @param {AdminAuthApiAdminAuthControllerAdminRegisterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAuthControllerAdminRegister(requestParameters: AdminAuthApiAdminAuthControllerAdminRegisterRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminRegisterCreatedDto> {
            return localVarFp.adminAuthControllerAdminRegister(requestParameters.adminRegisterReqBodyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminAuthControllerAdminChangePassword operation in AdminAuthApi.
 * @export
 * @interface AdminAuthApiAdminAuthControllerAdminChangePasswordRequest
 */
export interface AdminAuthApiAdminAuthControllerAdminChangePasswordRequest {
    /**
     * 
     * @type {AdminChangePasswordReqBodyDto}
     * @memberof AdminAuthApiAdminAuthControllerAdminChangePassword
     */
    readonly adminChangePasswordReqBodyDto: AdminChangePasswordReqBodyDto
}

/**
 * Request parameters for adminAuthControllerAdminLogin operation in AdminAuthApi.
 * @export
 * @interface AdminAuthApiAdminAuthControllerAdminLoginRequest
 */
export interface AdminAuthApiAdminAuthControllerAdminLoginRequest {
    /**
     * 
     * @type {AdminLoginReqBodyDto}
     * @memberof AdminAuthApiAdminAuthControllerAdminLogin
     */
    readonly adminLoginReqBodyDto: AdminLoginReqBodyDto
}

/**
 * Request parameters for adminAuthControllerAdminRegister operation in AdminAuthApi.
 * @export
 * @interface AdminAuthApiAdminAuthControllerAdminRegisterRequest
 */
export interface AdminAuthApiAdminAuthControllerAdminRegisterRequest {
    /**
     * 
     * @type {AdminRegisterReqBodyDto}
     * @memberof AdminAuthApiAdminAuthControllerAdminRegister
     */
    readonly adminRegisterReqBodyDto: AdminRegisterReqBodyDto
}

/**
 * AdminAuthApi - object-oriented interface
 * @export
 * @class AdminAuthApi
 * @extends {BaseAPI}
 */
export class AdminAuthApi extends BaseAPI {
    /**
     * 
     * @summary 관리자 비밀번호 변경
     * @param {AdminAuthApiAdminAuthControllerAdminChangePasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuthApi
     */
    public adminAuthControllerAdminChangePassword(requestParameters: AdminAuthApiAdminAuthControllerAdminChangePasswordRequest, options?: RawAxiosRequestConfig) {
        return AdminAuthApiFp(this.configuration).adminAuthControllerAdminChangePassword(requestParameters.adminChangePasswordReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자 로그인
     * @param {AdminAuthApiAdminAuthControllerAdminLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdminAuthApi
     */
    public adminAuthControllerAdminLogin(requestParameters: AdminAuthApiAdminAuthControllerAdminLoginRequest, options?: RawAxiosRequestConfig) {
        return AdminAuthApiFp(this.configuration).adminAuthControllerAdminLogin(requestParameters.adminLoginReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자 로그아웃
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdminAuthApi
     */
    public adminAuthControllerAdminLogout(options?: RawAxiosRequestConfig) {
        return AdminAuthApiFp(this.configuration).adminAuthControllerAdminLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자 토큰 갱신
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuthApi
     */
    public adminAuthControllerAdminRefresh(options?: RawAxiosRequestConfig) {
        return AdminAuthApiFp(this.configuration).adminAuthControllerAdminRefresh(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자 생성
     * @param {AdminAuthApiAdminAuthControllerAdminRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuthApi
     */
    public adminAuthControllerAdminRegister(requestParameters: AdminAuthApiAdminAuthControllerAdminRegisterRequest, options?: RawAxiosRequestConfig) {
        return AdminAuthApiFp(this.configuration).adminAuthControllerAdminRegister(requestParameters.adminRegisterReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

